import { useEffect, useState } from "react";

// Third Party
import clsx from "clsx";

// MUI
import { Box, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, FormGroup, IconButton, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const commonClasses = "!font-sans !text-[14.5px] !font-normal !text-default";
const errorClasses = "!font-sans !text-[14.5px] !font-normal !text-error";

interface IExportReconciliationDialogProps {
	isOpen: boolean;
	onClose: () => void;
	isPending: boolean;
	mutateExportReconciliation: (vehicleTypes: string[]) => void;
	exportReconciliationError: string;
}

const ExportReconciliationDialog = (props: IExportReconciliationDialogProps) => {
	const { isOpen, onClose, mutateExportReconciliation, isPending, exportReconciliationError } = props;
	const [vehicleTypes, setVehicleTypes] = useState<string[]>([]);

	const handlerExport = () => {
		mutateExportReconciliation(vehicleTypes);
	};

	const disabledExport = !vehicleTypes?.length || isPending;

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked, value } = event.target;
		setVehicleTypes((prev) => (checked ? [...prev, value] : prev.filter((type) => type !== value)));
	};

	useEffect(() => {
		return () => {
			setVehicleTypes([]);
		};
	}, [isOpen]);

	return (
		<Dialog
			classes={{
				paper: "!rounded-[10px] !shadow-md pt-4 pb-2 !w-[310px]",
			}}
			open={isOpen}
			onClose={onClose}
			disableEscapeKeyDown
			onDoubleClick={(e) => {
				e.stopPropagation();
			}}
		>
			<DialogTitle>
				<Typography className={commonClasses}>Please select what data you would like to export:</Typography>

				<IconButton className="!absolute !right-1 !top-1 !text-default" aria-label="close" onClick={onClose}>
					<CloseRoundedIcon fontSize="small" />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<FormGroup className="!flex !flex-col !-space-y-2 !-mt-2">
					<FormControlLabel
						control={<Checkbox value="New" onChange={handleCheckboxChange} disabled={isPending} />}
						label="New Vehicle Reconciliation"
						classes={{ label: commonClasses }}
					/>
					<FormControlLabel
						control={<Checkbox value="Used" onChange={handleCheckboxChange} disabled={isPending} />}
						label="Pre-Owned Vehicle Reconciliation"
						classes={{ label: commonClasses }}
					/>
				</FormGroup>
				{exportReconciliationError && <Typography className={errorClasses}>{exportReconciliationError}</Typography>}
				<Box className="!flex !flex-row !items-center !justify-end !mt-2">
					<LoadingButton
						variant="contained"
						disableElevation
						loading={isPending}
						className={clsx({
							"!rounded-md !h-[30px] !w-[84px] !text-sm !text-nowrap !text-white !capitalize !font-sans !px-6": true,
							"!bg-primary hover:!shadow-primary-shadow-50": !disabledExport,
							"!bg-disabled !fill-white": disabledExport,
						})}
						classes={{
							loadingIndicator: "!text-white",
						}}
						onClick={handlerExport}
						disabled={disabledExport}
					>
						{isPending ? null : "Export"}
					</LoadingButton>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default ExportReconciliationDialog;
